<template>
  <div class="con">
   <div class="txt" v-html="info.content">
     <p>
     </p>
   </div>
  </div>

</template>

<script>
export default {
  name: 'ruleDetaile',
  data () {
    return {
      type:'',
      info:{},// 详情
    }
  },
  mounted(){
    if(this.getUrlParamURLys("type")){
      this.type=this.getUrlParamURLys("type");
      this.getinfo();
    }

  },
  methods:{
    getinfo:function () {
      var _this=this;
      _this.call_net("POST","/api/app/singlepage/info",{type:_this.type},function (data) {
        if(data.code===200){
          _this.info=data.data;
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con{
    padding: 0.3rem;
    padding-top:0.4rem;
  }
  .txt >>> p,.txt >>> span,.txt{
    font-size: 0.28rem !important;
    color: #666 !important;
    line-height: 0.5rem;
    font-family: "微软雅黑" !important;
    font-style: normal !important;
  }
  .txt>>>img{
    display: block;
    width: 100%;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/reportdetaile.vue